<app-list-header
  name="exportTask"
  [canCreate]="true"
  [canSearch]="false"
  (onCreate)="create()">
</app-list-header>

<app-item-list
  [columns]="columns"
  [actions]="actions"
  [orangeMarker]="orangeMarker"
  [greenMarker]="greenMarker"
  [redMarker]="redMarker"
  [items$]="exportTasks$"
  [clickable]="false"
  (onChangePage)="changePage($event.pageIndex, $event.pageSize)">
</app-item-list>

@if (isLoading) {
  <app-loader [transparent]="true"></app-loader>
}
